var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentVariation
    ? _c("add-to-basket", {
        attrs: {
          "variation-id": _vm.currentVariation.variation.id,
          "is-salable":
            !!_vm.currentVariation.filter &&
            _vm.currentVariation.filter.isSalable,
          "has-children":
            !!_vm.currentVariation.filter &&
            _vm.currentVariation.filter.hasActiveChildren,
          "interval-quantity":
            _vm.currentVariation.variation.intervalOrderQuantity || 1,
          "minimum-quantity":
            _vm.currentVariation.variation.minimumOrderQuantity,
          "maximum-quantity":
            !!_vm.currentVariation.variation.maximumOrderQuantity &&
            _vm.currentVariation.variation.maximumOrderQuantity > 0
              ? _vm.currentVariation.variation.maximumOrderQuantity
              : null,
          "order-properties": _vm.currentVariation.properties.filter(function(
            prop
          ) {
            return prop.property.isOderProperty
          }),
          "has-order-properties": _vm.currentVariation.hasOrderProperties,
          "has-required-order-property":
            _vm.currentVariation.hasRequiredOrderProperty,
          "use-large-scale": false,
          "show-quantity": true,
          "item-url": _vm._f("itemURL")(_vm.currentVariation),
          "has-price": _vm._f("hasItemDefaultPrice")(_vm.currentVariation),
          "button-size": _vm.buttonSize,
          "padding-classes": _vm.paddingClasses,
          "padding-inline-styles": _vm.paddingStyles,
          "data-testing": "single-add-to-basket-button"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }